import axios, { getEnv } from '../../../services/api';
import Axios from 'axios';

export const VinculoEmpresaService = {
  findAll: async (params, body = {}, source) => {
    try {
      const response = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/vinculos/consultar`,
        body,
        {
          params,
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log('Requisição cancelada', error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  find: async (idVersao) => {
    try {
      const response = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/atendimentos-sas/tipos/${idVersao}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  getPedants: async (body = {}) => {
    try {
      const response = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/atendimentos-sas/tipos/buscar-pendentes`,
        body
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  save: async (body) => {
    const response = await axios.post(
      `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/tipos`,
      body
    );
    return response.data;
  },

  update: async (body) => {
    try {
      return await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/tipos`,
        body
      );
    } catch (error) {
      return error;
    }
  },

  associar: async (cpf, cnpj, donoEmpresa) => {
    try {
      return await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/cpf/${cpf}/associar/empreendedor/cnpj/${cnpj}/dono-da-empresa/${
          donoEmpresa === 'OUTRO' ? false : true
        }`
        // {},
        // { params }
      );
    } catch (error) {
      throw error;
    }
  },
  desassociar: async (cpf, cnpj) => {
    try {
      return await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/cpf/${cpf}/desassociar/empreendedor/cnpj/${cnpj}`
        // {},
        // { params }
      );
    } catch (error) {
      throw error;
    }
  },
  delete: async (idVersao) => {
    try {
      return await axios.delete(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/atendimentos-sas/tipos/${idVersao}`
      );
    } catch (error) {
      return error;
    }
  },

  getFilterOptions: async () => {
    try {
      const response = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/opcoes`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  searchInput: async (body, params, source) => {
    const response = await axios.post(
      `${await getEnv(
        'REACT_APP_URL_SERVICE'
      )}/v1/atendimentos-sas/tipos/consultar`,
      body,
      {
        params,
        cancelToken: source.token,
      }
    );
    source.cancel('Operação cancelada pelo usuário');
    return response.data;
  },

  consultar: async (body, params) => {
    const response = await axios.post(
      `${await getEnv(
        'REACT_APP_URL_SERVICE'
      )}/v1/atendimentos-sas/tipos/consultar?page=0&linesPerPage=10&orderBy=id&direction=ASC`,
      body,
      { params }
    );
    return response.data;
  },
};
